<template>
     <div class="p20" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">修改其他收付单</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard" v-if="!loading"> 
            <ly-product-table 
                ref="productTable"
                v-model="submitForm.data"
                :is-delete="false"
                :is-add="false"
                :is-copy="false"
                :thead-config="productConfig">
            </ly-product-table>
        </el-card>
        <!-- 商品选择组件 end -->
        <span v-show="false">{{totalAmount}}</span>
    </div>
</template>
<script>
    /**
     * 胎号管理的修改页面
     * @author zjs
     * @time 2017-09-18
     */
    import AddProductConfig from './add-product'
    import LyProductTable from '@c/product-table'
    import LyRouterButton from '@c/router-button'
    import AddRulesConfig from './rules'
    export default {
        mixins: [
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LyProductTable,
            LyRouterButton
        },
        data () {
            return {
                loading: true,
                submitLoad: false, // 提交按钮的状态标识
                infoId: 0,
                submitForm: {
                    uuid: '',
                    data: []
                } // 提交的表单数据
            }
        },
        computed: {
            totalAmount () {
                let total = 0 
                this.submitForm.data.forEach(function (el, index, originalArr) {
                    // 计算实时余额
                    if (el.wlye) {
                        total = el.customer.ss_amount = (parseFloat(el.wlye.amount) + parseFloat(el.amount || 0)).toFixed(2)
                    }
                }, this)
                return total
            }
        },
        created () {
            AddProductConfig.isTriggerFunc = false
            this.init()
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'PaymentOtherpayEdit') {
                    this.init()
                }
            }
        },
        methods: {
            init () {
                // 获取详情的ID
                this.infoId = this.$route.params.id
                // 设置UUID
                this.submitForm.uuid = this.$utils.createUUID()
                if (this.infoId) {
                    this.queryEditData()
                } else {
                    this.$message({
                        message: '无ID',
                        type: 'warning'
                    })
                }
            },
            /**
             * 获取要修改的数据
             */
            queryEditData () {
                this.$api.queryArr(['api/qitasf', 'edit'], null, [this.infoId]).then((rs) => {
                    this.submitForm.data.push(rs.data)
                    // 取消加载
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                }).catch((error) => {
                    // 取消加载
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            submit () {
                if (this.submitForm.data.length > 0) {
                    // 货品验证
                    let productMsg = this.validateProduct(this.productList)
                    // 货品验证不通过的情况
                    if (productMsg.length > 0) {
                        this.$alert(productMsg, '提示', {
                            confirmButtonText: '确定'
                        })
                    } else {
                        this.submitLoad = true
                        // 提交数据
                        this.$api.save('api/qitasf/' + this.infoId, this.submitForm).then((rs) => {
                            this.$alert('数据提交成功', '更新', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.submitLoad = false
                                    // 跳转到详情页面
                                    this.$router.push('/bill/qitasf/info/' + this.infoId)
                                }
                            })
                            // 更新UUID
                            this.submitForm.uuid = this.$utils.createUUID()
                        }).catch((error) => {
                            this.submitLoad = false
                            this.$message({
                                message: error,
                                type: 'warning'
                            })
                        })
                    }
                } else {
                    this.$message({
                        message: '请输入单据',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>